import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./slices/user_slice";
import commonSlice from "./slices/common_slice";
import form_slice from "./slices/form_slice";
import currency_slice from "./slices/currency_slice";
import dashboard_slice from "./slices/dashboard_slice";

const rootReducer = combineReducers({
  user: userSlice,
  common: commonSlice,
  form: form_slice,
  currency: currency_slice,
  dashboard: dashboard_slice
});

export default rootReducer;
